import pb from '../lib/pocketbase.js';

// Obtener las escoltas de un drop paginadas
export async function getEgresoDropEscoltas(egresoDropId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDropEscolta').getList(page, perPage, {
      filter: `egresoDrop = "${egresoDropId}"`,
      $autoCancel: false,
      expand: "escolta",
      timeout: 10000 // 10 second timeout
    });
    return {
      items: response.items || [],
      totalItems: response.totalItems || 0,
      page: response.currentPage || 1,
    };
  } catch (error) {
    console.error("Error fetching egresoDropEscolta:", error);
    // Return empty result instead of throwing to prevent cascade failures
    return {
      items: [],
      totalItems: 0,
      page: 1,
    };
  }
}

// Crear una nueva escolta para un drop
export async function createEgresoDropEscolta(egresoDropEscolta) {
  try {
    const response = await pb.collection('egresoDropEscolta').create(egresoDropEscolta);
    return response;
  } catch (error) {
    console.error("Error creating egresoDropEscolta:", error);
    throw new Error("Error al crear la escolta del drop");
  }
}

// Actualizar una escolta de drop existente
export async function updateEgresoDropEscolta(id, egresoDropEscolta) {
  try {
    const response = await pb.collection('egresoDropEscolta').update(id, egresoDropEscolta);
    return response;
  } catch (error) {
    console.error("Error updating egresoDropEscolta:", error);
    throw new Error("Error al actualizar la escolta del drop");
  }
}

// Eliminar una escolta de drop
export async function deleteEgresoDropEscolta(id) {
  try {
    await pb.collection('egresoDropEscolta').delete(id);
  } catch (error) {
    console.error("Error deleting egresoDropEscolta:", error);
    throw new Error("Error al eliminar la escolta del drop");
  }
}

// Eliminar todas las escoltas de un drop
export async function deleteAllEscoltasFromDrop(egresoDropId) {
  try {
    const existingEscoltas = await pb.collection('egresoDropEscolta').getFullList({
      filter: `egresoDrop = "${egresoDropId}"`,
      $autoCancel: false,
    });
    
    for (const escolta of existingEscoltas) {
      await pb.collection('egresoDropEscolta').delete(escolta.id);
    }
    return { success: true };
  } catch (error) {
    console.error('Error al eliminar escoltas del drop:', error);
    throw error;
  }
}

// Agregar múltiples escoltas a un drop
export async function addEscoltasToDrop(egresoDropId, escoltaIds) {
  try {
    const promises = escoltaIds.map(escoltaId =>
      pb.collection('egresoDropEscolta').create(
        {
          egresoDrop: egresoDropId,
          escolta: escoltaId,
        },
        { $autoCancel: false }
      )
    );
    await Promise.all(promises);
    return { success: true };
  } catch (error) {
    console.error('Error al agregar escoltas al drop:', error);
    throw error;
  }
}

// Obtener una escolta de drop por ID
export async function getEgresoDropEscoltaById(id) {
  try {
    const response = await pb.collection('egresoDropEscolta').getOne(id, {
      expand: "escolta"
    });
    return response;
  } catch (error) {
    console.error("Error fetching egresoDropEscolta by ID:", error);
    throw new Error("Error al obtener la escolta del drop");
  }
} 